import React from 'react';
import { db } from '../../database/config';

// Location Icon
const LocationIcon = () => (
    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"></path>
        <circle cx="12" cy="9" r="2.5"></circle>
    </svg>
);

// Phone Icon
const WhatsappIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"></path>
</svg>
);

// Email Icon
const EmailIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
        <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
);

// Sparkle Icon for header
const SparkleIcon = () => (
    <svg className="w-4 h-4 inline-block mr-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z"></path>
    </svg>
);

// Arrow Icons
const ArrowLeftIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
);

const ArrowRightIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
);

// Default city images for fallback
const defaultCityImages = {
    'delhi': 'https://images.unsplash.com/photo-1587474260584-136574528ed5?w=800&h=500&fit=crop',
    'mumbai': 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=800&h=500&fit=crop',
    'gurugram': 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=500&fit=crop',
    'gurgaon': 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=500&fit=crop',
    'bangalore': 'https://images.unsplash.com/photo-1596176530529-78163a4f7af2?w=800&h=500&fit=crop',
    'hyderabad': 'https://images.unsplash.com/photo-1572445530890-4a3f5c0c5c73?w=800&h=500&fit=crop',
    'chennai': 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=800&h=500&fit=crop',
    'kolkata': 'https://images.unsplash.com/photo-1558431382-27e303142255?w=800&h=500&fit=crop',
    'default': 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=500&fit=crop'
};

const getCityImage = (city, providedImg) => {
    if (providedImg && providedImg.trim() !== '') {
        return providedImg;
    }
    const cityLower = city?.toLowerCase() || '';
    return defaultCityImages[cityLower] || defaultCityImages['default'];
};

const LocationCard = ({ location, index, onPrev, onNext, totalLocations }) => {
    const cityImage = getCityImage(location.city, location.img);

    return (
        <div className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 group">
            {/* Background Image */}
            <div className="relative h-72 md:h-80 lg:h-96">
                <img
                    src={cityImage}
                    alt={`${location.city} - BentoBox Service Location`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-blue-400/20 via-purple-300/30 to-pink-200/40"></div>
            </div>

            {/* Info Card - Positioned at bottom right */}
            <div className="absolute bottom-4 right-4 left-4 md:left-auto md:w-80 bg-white rounded-xl shadow-xl p-5">
                {/* City Name */}
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {location.city}
                </h3>

                {/* Description */}
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {location.heading}
                </p>

                {/* Address */}
                <div className="flex items-start gap-2 mb-3">
                    <div className="text-gray-400 mt-0.5">
                        <LocationIcon />
                    </div>
                    <p className="text-gray-600 text-sm">
                        {location.address}
                    </p>
                </div>

                {/* Phone */}
                <div className="flex items-center gap-2 mb-2">
                    <div className="text-gray-400">
                        <WhatsappIcon />
                    </div>
                    <a
                        href={`tel:${location.whatsappNumber}`}
                        className="text-gray-600 text-sm hover:text-orange-500 transition-colors"
                    >
                        {location.whatsappNumber}
                    </a>
                </div>

                {/* Email */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="text-gray-400">
                            <EmailIcon />
                        </div>
                        <a
                            href={`mailto:${location.email}`}
                            className="text-gray-600 text-sm hover:text-orange-500 transition-colors"
                        >
                            {location.email}
                        </a>
                    </div>

                    {/* Navigation Arrows */}
                    {totalLocations > 1 && (
                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => onPrev(index)}
                                className="w-8 h-8 rounded border border-orange-500 flex items-center justify-center text-orange-500 hover:bg-orange-50 transition-colors"
                                aria-label="Previous location"
                            >
                                <ArrowLeftIcon />
                            </button>
                            <button
                                onClick={() => onNext(index)}
                                className="w-8 h-8 rounded bg-orange-500 flex items-center justify-center text-white hover:bg-orange-600 transition-colors"
                                aria-label="Next location"
                            >
                                <ArrowRightIcon />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const Locations = ({ preloadedData }) => {
    const topSection = preloadedData?.topSection || {
        Orangeheading: 'Our Address',
        heading: 'Check Out Our Locations'
    };
    const locations = preloadedData?.locations || [];

    const scrollToLocation = (targetIndex) => {
        const locationCards = document.querySelectorAll('[data-location-card]');
        if (locationCards[targetIndex]) {
            locationCards[targetIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    };

    const handlePrev = (currentIndex) => {
        const prevIndex = currentIndex === 0 ? locations.length - 1 : currentIndex - 1;
        scrollToLocation(prevIndex);
    };

    const handleNext = (currentIndex) => {
        const nextIndex = currentIndex === locations.length - 1 ? 0 : currentIndex + 1;
        scrollToLocation(nextIndex);
    };


    return (
        <section id="locations" className="!pt-12 md:!pt-16 bg-gradient-to-b from-orange-50/50 to-white ">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-16 md:pt-12 md:pb-24">
                {/* Header */}
                <div className="text-center mb-12 md:mb-16">
                    <span className="text-orange-500 font-semibold text-sm tracking-widest uppercase inline-flex items-center">
                        <SparkleIcon />
                        {topSection.Orangeheading}
                    </span>
                    <h1 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
                        {topSection.heading}
                    </h1>
                </div>

                {/* Breadcrumb */}
                <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-10">
                    <a href="/" className="hover:text-orange-500 transition-colors">Home</a>
                    <span>/</span>
                    <span className="text-gray-700">Locations</span>
                </div>

                {/* Locations List */}
                {locations.length > 0 ? (
                    <div className="space-y-10">
                        {locations.map((location, index) => (
                            <div key={location.id} data-location-card>
                                <LocationCard
                                    location={location}
                                    index={index}
                                    onPrev={handlePrev}
                                    onNext={handleNext}
                                    totalLocations={locations.length}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-12 text-gray-500">
                        No locations available yet.
                    </div>
                )}
            </div>
        </section>
    );
};

export default Locations;
